// Lucian UX/UI Prompt #090 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#090
// 読み込みに失敗したとき。輪が縮んで次の自動再試行までの時間を見せる。自動は最大3回で、間を広げる
// （ダッシュボード API は1回で数千行を読むので、連打で D1 の読み取りを増やさない）。それ以降は押して再試行。
import React, { useEffect, useRef, useState } from 'react';
import { retryDelayMs } from '../../utils/home-viz.mjs';
import './lucian.css';

const RC = 2 * Math.PI * 18;

export default function RetryPanel({ attempt, onRetry, hasStale }) {
  const delay = retryDelayMs(attempt);
  const [left, setLeft] = useState(delay);
  const fired = useRef(false);

  useEffect(() => {
    fired.current = false;
    setLeft(delay);
    if (delay == null) return undefined;
    const started = Date.now();
    const id = setInterval(() => {
      const rest = Math.max(0, delay - (Date.now() - started));
      setLeft(rest);
      if (rest === 0 && !fired.current) { fired.current = true; clearInterval(id); onRetry(); }
    }, 250);
    return () => clearInterval(id);
  }, [attempt]);

  return (
    <div className="lx lx-card lx-retry" role="alert">
      <svg className="lx-retry__ring" viewBox="0 0 44 44" aria-hidden="true">
        <circle className="bg" cx="22" cy="22" r="18" />
        <circle className="fg" cx="22" cy="22" r="18" strokeDasharray={RC}
          strokeDashoffset={delay ? RC * (1 - (left || 0) / delay) : RC} />
      </svg>
      <div className="lx-retry__msg">
        <b>数字を読み込めませんでした。</b>
        {delay != null ? <> {Math.ceil((left || 0) / 1000)}秒後にもう一度試します。</> : <> 電波の良い場所で、もう一度押してください。</>}
        {hasStale && <><br />下は前回読み込めた数字です。</>}
      </div>
      <button type="button" className="lx-btn lx-btn--accent" onClick={onRetry}>今すぐ再試行</button>
    </div>
  );
}
